import InitialState from 'store/InitialState';
import { instructorCourseGCActionTypes as types } from 'Screens';

export default function instructorCourseGCReducer(state = InitialState.instructorCourseGC, action) {
    switch (action.type) {
        case types.LOAD_INSTRUCTOR_COURSE_GROUPS_SUCCESS:
            {
                let { courseid, groups } = action;
                let instructorCourseGroupsMap = new Map(state.instructorCourseGroupsMap);
                instructorCourseGroupsMap.set(courseid, groups);
                return {
                    ...state,
                    instructorCourseGroupsMap
                };
            }

        case types.LOAD_INSTRUCTOR_COURSE_GROUPS_FAILURE:
            return state;
        case types.ADD_INSTRUCTOR_COURSE_GROUPS_SUCCESS:
            {
                let { courseid, group } = action;
                let instructorCourseGroupsMap = new Map(state.instructorCourseGroupsMap);
                instructorCourseGroupsMap.get(courseid).push(group);
                return {
                    ...state,
                    instructorCourseGroupsMap
                };
            }
        case types.DELETE_INSTRUCTOR_COURSE_GROUPS_SUCCESS:
            {
                let { courseid, groupid } = action;
                let instructorCourseGroupsMap = new Map(state.instructorCourseGroupsMap);
                let instructorGroupConceptsMap = new Map(state.instructorGroupConceptsMap);
                let arr = instructorCourseGroupsMap.get(courseid).filter(group => {
                    return group.id !== groupid;
                });

                instructorGroupConceptsMap.delete(groupid);
                instructorCourseGroupsMap.set(courseid, arr);

                return {
                    instructorGroupConceptsMap,
                    instructorCourseGroupsMap
                };
            }
        case types.EDIT_INSTRUCTOR_COURSE_GROUPS_SUCCESS:
            {
                let { courseid, groupid, data } = action;
                let instructorCourseGroupsMap = new Map(state.instructorCourseGroupsMap);
                let i = instructorCourseGroupsMap.get(courseid).findIndex(group => {
                    return group.id === groupid;
                });
                instructorCourseGroupsMap.get(courseid)[i].title = data.title;
                instructorCourseGroupsMap.get(courseid)[i].description = data.description;
                return {
                    ...state,
                    instructorCourseGroupsMap
                };
            }

        case types.REORDER_INSTRUCTOR_COURSE_GROUPS_SUCCESS:
            {
                let { courseid, groups } = action;
                let instructorCourseGroupsMap = new Map(state.instructorCourseGroupsMap);

                instructorCourseGroupsMap.set(courseid, [...groups])
                return {
                    ...state,
                    instructorCourseGroupsMap
                }
            }

        case types.LOAD_INSTRUCTOR_GROUP_CONCEPTS_SUCCESS:
            let { groupid, concepts } = action;
            let instructorGroupConceptsMap = new Map(state.instructorGroupConceptsMap)
            instructorGroupConceptsMap.set(groupid, concepts);
            return {
                ...state,
                instructorGroupConceptsMap
            }

        case types.LOAD_INSTRUCTOR_GROUP_CONCEPTS_FAILURE:
            return state;

        case types.DELETE_INSTRUCTOR_GROUP_CONCEPTS_SUCCESS:
            {
                let { conceptid, groupid } = action;
                let instructorGroupConceptsMap = new Map(state.instructorGroupConceptsMap);
                let arr = instructorGroupConceptsMap.get(groupid).filter(concept => {
                    return concept.id !== conceptid;
                });

                instructorGroupConceptsMap.set(groupid, arr);

                return {
                    ...state,
                    instructorGroupConceptsMap
                };
            }
        case types.ADD_INSTRUCTOR_GROUP_CONCEPTS_SUCCESS:
            {
                let { data, groupid } = action;
                let instructorGroupConceptsMap = new Map(state.instructorGroupConceptsMap);
                let arr = [...instructorGroupConceptsMap.get(groupid)]
                arr.push(data);
                instructorGroupConceptsMap.set(groupid, arr);

                return {
                    ...state,
                    instructorGroupConceptsMap
                };
            }
        case types.PUBLISH_INSTRUCTOR_GROUP_CONCEPTS_SUCCESS:
            {
                let { conceptid, groupid } = action;
                let instructorGroupConceptsMap = new Map(state.instructorGroupConceptsMap);

                let newConcepts = instructorGroupConceptsMap.get(groupid).map(concept => {
                    if (concept.id == conceptid) {
                        return {
                            ...concept,
                            is_published: !concept.is_published
                        }
                    }
                    else {
                        return concept
                    }
                })
                instructorGroupConceptsMap.set(groupid, newConcepts);

                return {
                    ...state,
                    instructorGroupConceptsMap
                };
            }
        case types.REORDER_INSTRUCTOR_GROUP_CONCEPTS_SUCCESS:
            {
                let { groupid, concepts } = action;
                let instructorGroupConceptsMap = new Map(state.instructorGroupConceptsMap);

                instructorGroupConceptsMap.set(groupid, [...concepts])
                return {
                    ...state,
                    instructorGroupConceptsMap
                }
            }

        default:
            return state;
    }
}